import { useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import Breadcrumbs from '@components/@extended/Breadcrumbs';
import Loader from '@components/Loader';
import AddCategory from '@sections/apps/_categories/AddCustomer';
import AddLab from '@sections/apps/_labs/AddCustomer';
import AddUser from '@sections/apps/_users/AddCustomer';
import AuthGuard from '@utils/route-guard/AuthGuard';
import Drawer from './Drawer';
import HorizontalBar from './Drawer/HorizontalBar';
import Footer from './Footer';
import Header from './Header';

import { handlerDrawerOpen, useGetMenuMaster } from '@api/menu';
import { Role } from '@config/types';
import useConfig from '@hooks/useConfig';
import AuthGuardComponent from '@utils/route-guard/AuthGuardComponent';
import { useSWRConfig } from 'swr';
import { MenuOrientation } from '../../config';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { container, miniDrawer, menuOrientation } = useConfig();

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!downXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);
  const disableBreadCrumb = useMemo(() => {
    return (
      pathname !== '/apps/profiles/account/my-account' &&
      !pathname.includes('/sub-categories') &&
      !pathname.includes('/configurator') &&
      !pathname.includes('/reports')
    );
  }, [pathname]);
  const { cache } = useSWRConfig();

  useEffect(() => {
    for (const key of cache.keys()) {
      // console.info('=====Key:', key);
    }
  }, [cache]);
  if (menuMasterLoading) return <Loader />;

  return (
    <AuthGuard>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        {!isHorizontal ? <Drawer /> : <HorizontalBar />}

        <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
          <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
          {/* TODO:: */}
          <Container
            maxWidth={false}
            sx={{
              ...(container && { px: { xs: 0, sm: 2 } }),
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {disableBreadCrumb && <Breadcrumbs />}
            <Outlet />
            <Footer />
          </Container>
        </Box>
        <AuthGuardComponent allowedRoles={[Role.Admin, Role.LabAdmin]}>
          <AddUser />
          <AddCategory />
        </AuthGuardComponent>

        <AuthGuardComponent allowedRoles={[Role.Admin]}>
          {/* <AddCustomer /> */}
          <AddLab />
        </AuthGuardComponent>
      </Box>
    </AuthGuard>
  );
}
